import React, { useEffect } from 'react';
import { InformationOutline } from 'pcln-icons';
import { GenericBanner, Flex, Text } from 'pcln-design-system';
import analytics from '../../analytics/analytics';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import { useLoadingStateContext } from '../../hooks/useLoadingStateContext';
/**
 * ErrorComponent
 * @public
 */
const TryAgain = ({
  lastMessage
}) => {
  useEffect(() => {
    analytics.log({
      message: `TryAgain-component: ${lastMessage}`,
      source: 'TryAgain'
    });
  }, [lastMessage]);
  // Try to get context, but don't throw if not available
  let setOpenErrorComponent, setLoadingStatus;
  try {
    const chatUIContext = useChatUIContext();
    setOpenErrorComponent = chatUIContext === null || chatUIContext === void 0 ? void 0 : chatUIContext.setOpenErrorComponent;
  } catch (error) {
    console.warn('TryAgain: useChatUIContext must be used within a ChatUIContextProvider');
    setOpenErrorComponent = () => {};
  }
  try {
    const loadingStateContext = useLoadingStateContext();
    setLoadingStatus = loadingStateContext === null || loadingStateContext === void 0 ? void 0 : loadingStateContext.setLoadingStatus;
    useEffect(() => {
      if (setLoadingStatus) {
        setLoadingStatus(false);
      }
    }, [setLoadingStatus]);
  } catch (error) {
    console.warn('TryAgain: useLoadingStateContext must be used within a LoadingStateProvider');
    setLoadingStatus = () => {};
  }
  const tryAgainHandler = function () {
    if (setOpenErrorComponent) {
      setOpenErrorComponent(false);
    }
  };
  return React.createElement(Flex, {
    flexDirection: 'column',
    justifyContent: 'center',
    "data-testid": 'try-again'
  }, React.createElement(GenericBanner, {
    mx: 3,
    my: 3,
    p: 2,
    borderRadius: 'lg',
    color: 'background.light',
    iconLeft: React.createElement(InformationOutline, {
      color: 'warning.base',
      "data-testid": 'information-outline-icon'
    }),
    text: React.createElement(Text.span, {
      textStyle: 'subheading6'
    }, "I'm having some trouble coming up with a response right now.\u00A0", React.createElement(Text.span, {
      color: 'primary.base',
      textStyle: 'heading6',
      style: {
        textDecoration: 'none !important'
      }
    }, "Please try again.")),
    buttonClick: tryAgainHandler
  }));
};
export default TryAgain;